import React from 'react';

import {
  Container,
  LeftContainer,
  ItemCard,
  RightContainer,
} from './styles';

import {
  TextCustom,
  Line,
} from '../styles';

const SectionDetails = ({ taskDetail }) => {
  const LeftCard = () => (
    <LeftContainer>
      <ItemCard>
        <TextCustom size="14px" bold>Inquilino: </TextCustom>
        <TextCustom size="12px">{taskDetail.user_name}</TextCustom>
      </ItemCard>
      <Line margin="7px 0 7px 0" />
      <ItemCard>
        <TextCustom size="14px" bold>Endereço: </TextCustom>
        <TextCustom size="10px">
          {taskDetail.address}
        </TextCustom>
      </ItemCard>
      <Line margin="7px 0 7px 0" />
      <ItemCard>
        <TextCustom size="14px" bold color="#F07E31">Tipo de serviço: </TextCustom>
        <TextCustom size="12px">{taskDetail.service_name}</TextCustom>
      </ItemCard>
    </LeftContainer>
  );

  const RightCard = () => (
    <RightContainer>
      <TextCustom size="18px" color="#F07E31" bold margin="0 0 20px 0">O que fazer agora?</TextCustom>
      <TextCustom size="12px">
        Sua aprovação de orçamento é necessária para que o
        serviço seja efetuado. Informe a imobiliária sobre o
        profissional escolhido para que a contratação seja
        realizada.
      </TextCustom>
    </RightContainer>
  );

  return (
    <Container>
      <LeftCard />
      <RightCard />
    </Container>
  );
};

export default SectionDetails;
